import React, { createContext, useContext } from 'react'

import { NodeStep, NodeStepType } from '@ui/__generated__/graphql'
import { Config } from '@ui/stores/pipelinesWorkflow/NodeStepStore'
import { QueryState } from '@ui/stores/pipelinesWorkflow/QueryBuilderStore'

interface StepProviderType {
  step: NodeStep
  inputId: string
  queryConfig: QueryState
  config: Config
  setConfig: (stepId: string, nodeStepType: NodeStepType, config: Partial<Config>) => void
  openQueryBuilder: (stepId: string, inputId: string) => void
  openCodeEditor: () => void
  setNodeStepType: (nodeStepType: NodeStepType) => void
  setStepId: (stepId: string) => void
  handleUpdateStepConfig: (stepId: NodeStep['id'], config: Partial<Config>) => void
  handleSetSelectedStepOverlay: () => void
}

const StepContext = createContext<StepProviderType | undefined>(undefined)

export const useStepContext = () => {
  const context = useContext(StepContext)
  if (!context) {
    throw new Error('useStepProvider must be used within a StepProvider')
  }
  return context
}

export const StepProvider: React.FC<StepProviderType & { children: React.ReactNode }> = ({ children, ...value }) => (
  <StepContext.Provider value={value}>{children}</StepContext.Provider>
)
